import {
    Card,
    styled
} from "@mui/material";

export const RoundedCard = styled(Card)({
    borderRadius: 20
});
